import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=43bcbbc1&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=ts&"
export * from "./ContactInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=43bcbbc1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bcbbc1",
  null
  
)

export default component.exports